/** Redes configurables en Admin → Contacto (company_info). */
export const SOCIAL_NETWORKS = [
  { key: 'twitter_url', icon: 'bi-twitter-x', label: 'Twitter / X' },
  { key: 'instagram_url', icon: 'bi-instagram', label: 'Instagram' },
  { key: 'facebook_url', icon: 'bi-facebook', label: 'Facebook' },
  { key: 'linkedin_url', icon: 'bi-linkedin', label: 'LinkedIn' },
  { key: 'rss_url', icon: 'bi-rss', label: 'RSS' },
];

/** Acepta URLs con o sin https:// */
export function normalizeExternalUrl(url) {
  const trimmed = String(url || '').trim();
  if (!trimmed) return null;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  if (trimmed.startsWith('//')) return `https:${trimmed}`;
  return `https://${trimmed}`;
}

export function getCompanySocialLinks(company) {
  if (!company) return [];
  return SOCIAL_NETWORKS.map((net) => ({
    ...net,
    url: normalizeExternalUrl(company[net.key]),
  })).filter((item) => item.url);
}

export function resolveWhatsAppHref(company) {
  const fromConfig = normalizeExternalUrl(company?.whatsapp_url);
  if (fromConfig) return fromConfig;
  const phone = String(company?.contact?.phone || '').replace(/\D/g, '');
  return phone ? `https://wa.me/${phone}` : null;
}
